import { useState } from "react";
import { DataTable } from "mantine-datatable";

function DeviceTable(props) {
  const {
    data,
    columns,
    idAccessor,
    selectedRecords,
    setSelectedRecords,
    isRecordSelectable,
  } = props;

  const [sortStatus, setSortStatus] = useState({
    columnAccessor: "name",
    direction: "asc",
  });

  return (
    <>
      <DataTable
        withBorder
        borderRadius="sm"
        withColumnBorders
        highlightOnHover
        minHeight={300}
        height={500}
        records={data ? data : []}
        noRecordsText="No records to show"
        columns={columns ?? []}
        totalRecords={data?.length}
        sortStatus={sortStatus}
        onSortStatusChange={setSortStatus}
        onCellClick={(e) => {
          if (e.column.onClick) e.column.onClick(e);
        }}
        selectedRecords={idAccessor ? selectedRecords : null}
        onSelectedRecordsChange={setSelectedRecords}
        isRecordSelectable={isRecordSelectable ?? false}
        idAccessor={idAccessor}
      />
    </>
  );
}

export default DeviceTable;
